import { DefaultTheme, TColorProp } from 'styled-components';

export function getThemeColor(theme: DefaultTheme, prop: TColorProp): string {
  const [firstKey, secondKey] = (prop || '').split('.');

  if (!!secondKey) {
    return theme?.[firstKey]?.[secondKey];
  }

  return theme?.[firstKey];
}
